"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("../../../..");
var _dates = require("../../../../utils/dates");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NoticeMetaInfo = ({
  created,
  updated,
  hasAttachment,
  hasEvent,
  createdBy,
  variant = 'portal',
  createdByRole
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.NoticeMetaWrapper, {
    children: [Boolean(createdBy && variant === 'myPage') && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Group, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconUser, {
        primary: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
        semibold: true,
        size: "14px",
        primary: true,
        children: createdBy || 'Ukjent bruker'
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Group, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconHistory, {
        primary: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Text, {
        semibold: true,
        size: "14px",
        primary: true,
        children: [created && (0, _.getFormattedDate)(created, _dates.ddmmyyyy), updated && updated !== created && ` (Oppdatert: ${(0, _.getFormattedDate)(updated, _dates.ddmmyyyy)})`]
      })]
    }), (hasAttachment || hasEvent) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Group, {
      children: [hasAttachment && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Div, {
        title: "Oppslaget inneholder vedlegg",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconFile, {
          primary: true,
          size: "16px"
        })
      }), hasEvent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Div, {
        title: "Oppslaget har et arrangement",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconCalendar, {
          primary: true,
          size: "18px"
        })
      })]
    }), createdByRole && variant === 'myPage' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TagWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Tag, {
        light: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
          size: "14px",
          children: createdByRole === 'board' ? 'Styret' : 'Beboer'
        })
      })
    })]
  });
};
var _default = exports.default = NoticeMetaInfo;